import { render, staticRenderFns } from "./Teaser.vue?vue&type=template&id=5ee7159e&"
import script from "./Teaser.vue?vue&type=script&lang=js&"
export * from "./Teaser.vue?vue&type=script&lang=js&"
import style0 from "./Teaser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports